import { type Dayjs } from 'dayjs';

export const ReferralStatus = {
  referred: 'Referred',
  pendingAcceptance: 'Pending Acceptance',
  pendingAssignment: 'Pending Assignment',
  accountSetup: 'Account Setup',
  complianceBlock: 'Compliance Block',
  pendingCompliance: 'Pending Compliance',
  pendingFirstPayrollRun: 'Pending First Payroll Run',
  missingInformation: 'Missing Information',
} as const;
export type ReferralStatus = (typeof ReferralStatus)[keyof typeof ReferralStatus];

export class Referral {
  public name: string;
  public status: ReferralStatus;
  public startDate: string;
  public aging: number;

  constructor(name: string, startDate: Dayjs, status: ReferralStatus) {
    this.name = name;
    this.status = status;
    this.startDate = startDate.isValid() ? startDate.format('MM/DD/YYYY') : '-';
    this.aging = 0;
  }
}
